import { render, staticRenderFns } from "./VendasPerdidas.vue?vue&type=template&id=cda07546&"
import script from "./VendasPerdidas.vue?vue&type=script&lang=js&"
export * from "./VendasPerdidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports